const PranesimasApiePatvirtinima = '401'
const PranesimasApiePakeitima = '402'
const TarnybinisApieNetikslumus = '403'
const PranesimasApiePasibaigima = '404'
const TarnybinisApieKlaidingaiIregistruota = '405'
const AutomatinisIšregistravimas = '406'
const Igaliojimas = '407'
const PareiskimasDelPanaikinimo = '408'
const PareiskimasDelAtsisakymo = '409'
const PranesimasApieITPSIPasibaigima = '410'
const PranesimasApiePripazinimaNeziniaKurEsanciuIgaliojimas = '411'
const Perigaliojimas = '412'
const AsmeniuiMirus = '413'
const AsmuoNeveiksnus = '414'
const JAIsregistravimas = '415'
const JATeisinioStatusoIregistravima = '416'
const TerminuiPasibaugus = '417'
const AutomatinisPerigaliojimoIsregistravimas = '418'
const Prokura = '420'
const ProkuraIsdavusioJADelProkurosIregistravimo = '421'
const ProkuraIsdavusioJADelProkurosPabaigos = '422'
const ProkuristoDelProkurosPabaigos = '423'
const PranesimasApieIgaliojimoPasibaigima = '424'
const PranesimasApieProkurosPasibaigima = '425'
const PranesimasApieIgaliojimoSustabdyma = '426'
const PranesimasApieProkurosSustabdyma = '427'
const PranesimasApieIgaliojimoSustabdymoPanaikinima = '428'
const PranesimasApieProkurosSustabdymoPanaikinima = '429'
const PranesimasApiePripazinimaNeziniaKurEsanciuProkuros = '430'
const PranesimasApieNeziniaKurEsanti = '499'

export default {
    PRANESIMAS_APIE_PATVIRTINIMA: PranesimasApiePatvirtinima,
    PRANESIMAS_APIE_PAKEITIMA: PranesimasApiePakeitima,
    TARNYBINIS_APIE_NETIKSLUMUS: TarnybinisApieNetikslumus,
    PRANESIMAS_APIE_PASIBAIGIMA: PranesimasApiePasibaigima,
    TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA: TarnybinisApieKlaidingaiIregistruota,
    AUTOMATINIS_ISREGISTRAVIMAS: AutomatinisIšregistravimas,
    IGALIOJIMAS: Igaliojimas,
    PAREISKIMAS_DEL_PANAIKINIMO: PareiskimasDelPanaikinimo,
    PAREISKIMAS_DEL_ATSISAKYMO: PareiskimasDelAtsisakymo,
    PRANESIMAS_APIE_ITPSI_PASIBAIGIMA: PranesimasApieITPSIPasibaigima,
    PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_IGALIOJIMAS: PranesimasApiePripazinimaNeziniaKurEsanciuIgaliojimas,
    PERIGALIOJIMAS: Perigaliojimas,
    ASMENIUI_MIRUS: AsmeniuiMirus,
    ASMUO_NEVEIKSNUS: AsmuoNeveiksnus,
    JA_ISREGISTRAVIMAS: JAIsregistravimas,
    JA_TEISINIO_STATUSO_IREGISTRAVIMAS: JATeisinioStatusoIregistravima,
    TERMINUI_PASIBAIGUS: TerminuiPasibaugus,
    AUTOMATINIS_PERIGALIOJIMO_ISREGISTRAVIMAS: AutomatinisPerigaliojimoIsregistravimas,
    PROKURA: Prokura,
    PROKURA_ISDAVUSIO_JA_DEL_PROKUROS_IREGISTRAVIMO: ProkuraIsdavusioJADelProkurosIregistravimo,
    PROKURA_ISDAVUSIO_JA_DEL_PROKUROS_PABAIGOS: ProkuraIsdavusioJADelProkurosPabaigos,
    PROKURISTO_DEL_PROKUROS_PABAIGOS: ProkuristoDelProkurosPabaigos,
    PRANESIMAS_APIE_IGALIOJIMO_PASIBAIGIMA: PranesimasApieIgaliojimoPasibaigima,
    PRANESIMAS_APIE_PROKUROS_PASIBAIGIMA: PranesimasApieProkurosPasibaigima,
    PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMA: PranesimasApieIgaliojimoSustabdyma,
    PRANESIMAS_APIE_PROKUROS_SUSTABDYMA: PranesimasApieProkurosSustabdyma,
    PRANESIMAS_APIE_IGALIOJIMO_SUSTABDYMO_PANAIKINIMA: PranesimasApieIgaliojimoSustabdymoPanaikinima,
    PRANESIMAS_APIE_PROKUROS_SUSTABDYMO_PANAIKINIMA: PranesimasApieProkurosSustabdymoPanaikinima,
    PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_PROKURA: PranesimasApiePripazinimaNeziniaKurEsanciuProkuros,
    PRANESIMAS_APIE_NEZINIA_KUR_ESANTI_BENDRAS: PranesimasApieNeziniaKurEsanti,
}
